/* A hands-on task.

   It is a box that says what it is before it says anything else: on a page of
   prompts and tables the reader has to see at a glance which one is the thing
   they are meant to do something with, and how long it takes.

   OWNED BY ITEM 3 OF docs/plan/00-prestavba-2026-08.md. */

import { useI18n } from "../lib/i18n";
import { Box, T } from "./shared";
import type { ExerciseBlock } from "../lib/types";

export function Exercise({ b }: { b: ExerciseBlock }) {
  const { ui } = useI18n();
  return (
    <div className="exercise">
      <div className="eyebrow">
        {ui("block.exercise")}{b.minutes ? ` · ${b.minutes} min` : ""}
      </div>
      {b.title ? <h3><T value={b.title} /></h3> : null}
      {b.lead ? <div className="lead"><T value={b.lead} /></div> : null}
      <Box text={b.brief} cls="prose" />
      <Box text={b.prompt} cls="prompt" dflt="block.prompt" copy />
      {b.done?.length ? (
        <div className="note">
          <h4>{ui("block.done")}</h4>
          <ul>{b.done.map((d, i) => <li key={i}><T value={d} /></li>)}</ul>
        </div>
      ) : null}
    </div>
  );
}
